import Request from '~/providers/Request';

const fetchPartners = async (input, page, resolve) => {
  await Request.get('/admin/partner', {
      sorter: 'name.asc',
      qs: input,
      page: page,
      perPage: 50
    }).then(resp => {
    const items = resp.data.map( e => ({
      id: Number(e.id),
      name: `${e.name}`
    }));
    resolve(
      {
        total_count: resp.meta.total,
        items
      }
    );
  });
};

export default fetchPartners;
